
import React, { useState } from "react";
import { Toaster, } from "react-hot-toast";
import Sidebar from "./Sidebar";
import { Outlet } from "react-router-dom";
const DashboardLayout = () => {
  
  const [active, setActive] = useState("profile");
  return (
    <div className="h-screen overflow-y-auto">
      <Toaster />
      <section className="flex justify-start gap-x-10 h-full">
        <Sidebar active={active} setActive={setActive} />
        <Outlet />
      </section>
    </div>
  );
};

export default DashboardLayout;